import React from "react"
import { IWidgetSet, Scalars } from "../../../gatsby-graphql"
import { WidgetsWrapper } from "./widgets-set-elements"
import WidgetLoader from "../../widgets/widget-loader"

interface WidgetSetProps {
  data: IWidgetSet
  locale?: string
}

export default function WidgetsSet({ data, locale }: WidgetSetProps) {
  return (
    <WidgetsWrapper>
      {data.widgets &&
        data.widgets.length > 0 &&
        data.widgets.map((widget: Scalars["JSON"], index: number) => (
          <WidgetLoader data={widget} locale={locale} key={index} />
        ))}
    </WidgetsWrapper>
  )
}
